import { z } from "zod";

import { reportingPeriodMapSchema } from "../../reporting-period";
import { employeeBalanceMapSchema } from "./balance";
import { employeeChecksMapSchema } from "./employeeCheck";

export const common = z.object({
  companyID: z.string(),
  policyID: z.string(),
  employeeBalanceMap: employeeBalanceMapSchema,
  employeeChecksMap: employeeChecksMapSchema,
  reportingPeriodMap: reportingPeriodMapSchema,
});
